import { CMSApiBase, createCmsUrl } from './base';
import { request } from '@/api/base';
import { snakify } from '@/helpers/common';
import { CLIENT_ENVS } from '@/helpers/constants';

export interface ThirdPartySummaryCommon {
  userId: number;
  modalId: string;
}

export type ThirdPartySummary = ThirdPartySummaryCommon & CMSApiBase;

export const pushThirdPartySummaries = (summary: ThirdPartySummaryCommon) =>
  request<ThirdPartySummary>({
    method: 'POST',
    url: `${CLIENT_ENVS.CMS_URL}/third-party-summaries`,
    data: snakify(summary),
  });
